import {SET_SELECTED_OBJECTS} from '../constants/selectedObjectsActionTypes';

export function setSelectedObjects(objectNames, objects) {
  return {
    type: SET_SELECTED_OBJECTS,
    objectNames,
    objects,
  };
}
